import FormData from "csi/action/FormData";
import { Context } from "csi/def/Context";
import Widget from "csi/table/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const DSSelectionForSharedDSCreationTable = declare(Widget, {

	/** Supplier or SupplierFactory string - set from CreateSharedDataSheetsWizardStore */
	productSourceCreationLevel: null,
	/** List of products to get the dataSheets from - set from CreateSharedDataSheetsWizardStore */ 
	selectedProducts: null,
	/** RequestType of the SR - set from CreateSharedDataSheetsWizardStore */
	productType: null,
	/** DataSheet Type - set from CreateSharedDataSheetsWizardStore */
	dataSheetType: null,
	/** Selected source - set from CreateSharedDataSheetsWizardStore */
	selectedSourceUrl: null,
	/** Map of Source to Linked Host DataSheets of dataSheets in ProductSources - set from CreateSharedDataSheetsWizardStore */
	sourceLinkedHostDatasheetMap: null,
	/** Switch state to show only new shared dataSheets - - set from CreateSharedDataSheetsWizardStore */
	showOnlyNewSharedDataSheets: null,

	/**
	 * @override
	 */
	_resolveView() {
		this.relRoot.m_typeNode = this.dataSheetType;
		this.inherited(arguments);
	},

	/**
	 * @override
	 */
	_buildView() {
		if (!this.showOnlyNewSharedDataSheets) {
			const fd = this.defView.getFormData();
			fd.m_bOmitSelections = true;
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
		}
		this.inherited(arguments);
	},

	/**
	 * Method to filter dataSheets that are already copied
	 * @param ctx
	 * @param fd 
	 * @returns 
	 */
	_isPreSelected(ctx: Context, fd: FormData): boolean {
		const { sourceLinkedHostDatasheetMap, selectedSourceUrl } = this;
		return sourceLinkedHostDatasheetMap[selectedSourceUrl]?.includes(ctx.getNodeURL());
	},

	/**
	 * @override 
	 * Add query to get only DataSheets of the selected products 
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		const { selectedProducts, productType, showOnlyNewSharedDataSheets, sourceLinkedHostDatasheetMap, selectedSourceUrl, productSourceCreationLevel } = this;

		if (selectedProducts?.length) {
			const q = new Query();
			const qOr = q.Or();
			selectedProducts.forEach((product) => {
				qOr.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, product);
			});
			q.Node(xml.PROP_TYPE, xml.OP_EQUALS, productType, "Child:__Parent__");
			q.RefAttr(productSourceCreationLevel, xml.OP_EQUALS, selectedSourceUrl, "Child:__Parent__/Child:ProductSourcing/Child:ProductSources");
			q.Attr("LinkedSourceDataSheets", xml.OP_EQUALS, "LinkedSourceDataSheets:Enabled", "Child:Subtype/Child:Settings");
			q.Attr("State", xml.OP_NOT_EQUALS, "Revision.State:APPROVED", "Child:CurrentRevision");
			q.Attr("State", xml.OP_NOT_EQUALS, "Revision.State:ABANDONED", "Child:CurrentRevision");
			if (showOnlyNewSharedDataSheets && !!sourceLinkedHostDatasheetMap[selectedSourceUrl]?.length) {
				sourceLinkedHostDatasheetMap[selectedSourceUrl].forEach((ds) => {
					q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, ds);
				});
			}
			if (!q.isEmpty()) {
				ql.serverQuery = q;
			}
		}
	},

});

export = DSSelectionForSharedDSCreationTable;